/**
 * ACCS Site Entry Point
 * Imports the shared unified lead tracker and applies ACCS-specific configuration
 */

import siteConfig from './site-config'

// IMPORTANT: Make site config available globally BEFORE importing the unified lead tracker
// This ensures the tracker can access the brand immediately
if (typeof window !== 'undefined') {
  (window as any).__SITE_CONFIG__ = siteConfig

  // Log site configuration in debug mode
  if (siteConfig.features?.debugMode) {
    console.log('🏢 ACCS Site Config Set:', {
      brand: siteConfig.brand,
      displayName: siteConfig.displayName,
      features: siteConfig.features,
      version: process.env.NODE_ENV
    })
  }
}

// Import the shared unified lead tracker AFTER setting site config
// This imports from the shared /src/ directory (../../src/)
import '../../src/unified-lead-tracker'

// Export site config for access from shared code if needed
export { siteConfig }
